<template>
  <section class="process">

    <div class="process__container container">

      <div class="process__title">
        <h2 class="process__title--h2">Exalab te acompaña</h2>
        <p class="process__title--p">en todo tu proceso de <strong class="process__title--strong">exámenes
            preocupacionales</strong></p>
      </div>

      <div class="process__diagram">

        <div class="process__diagram--content">

           <a name="process-item-1" class="process__diagram--item">
            <div class="process__diagram--circle">
              <div class="process__diagram--number">2</div>
              <div class="process__diagram--icon" style="color: hsla(55,67%,52%,1);">
                <i class="process__diagram--i ri-calendar-schedule-line"></i>
              </div>
            </div>

            <div class="process__diagram--title">
              <h3 class="process__diagram--h3">Solicitud<br class="br-escritorio"> de atención</h3>
            </div>
          </a>

          <a name="process-item-2" class="process__diagram--item">
            <div class="process__diagram--circle">
              <div class="process__diagram--number">2</div>
              <div class="process__diagram--icon">
                <i class="process__diagram--i ri-stethoscope-line"></i>
              </div>
            </div>

            <div class="process__diagram--title">
              <h3 class="process__diagram--h3">Atención<br class="br-escritorio"> de paciente</h3>
            </div>
          </a>

          <a name="process-item-3" class="process__diagram--item">
            <div class="process__diagram--circle">
              <div class="process__diagram--number">3</div>
              <div class="process__diagram--icon">
                <i class="process__diagram--i ri-file-edit-line"></i>
              </div>
            </div>

            <div class="process__diagram--title">
              <h3 class="process__diagram--h3">Firma y emisión<br class="br-escritorio"> de informes</h3>
            </div>
          </a>

          <a name="process-item-4" class="process__diagram--item">
            <div class="process__diagram--circle">
              <div class="process__diagram--number">4</div>
              <div class="process__diagram--icon">
                <i class="process__diagram--i ri-hospital-line"></i>
              </div>
            </div>

            <div class="process__diagram--title">
              <h3 class="process__diagram--h3">Operaciones</h3>
            </div>
          </a>

          <a name="process-item-5" class="process__diagram--item">
            <div class="process__diagram--circle">
              <div class="process__diagram--number">5</div>
              <div class="process__diagram--icon">
                <i class="process__diagram--i ri-line-chart-line"></i>
              </div>
            </div>

            <div class="process__diagram--title">
              <h3 class="process__diagram--h3">Finanzas</h3>
            </div>
          </a>

        </div>

        <div class="process__diagram--line">
          <div class="process__diagram--arrow"></div>
          <div class="process__diagram--arrow"></div>
          <div class="process__diagram--arrow"></div>
          <div class="process__diagram--arrow"></div>
        </div>

        <!-- Bullets -->
        <ul class="process__diagram--bullets">
          <li class="process__diagram--bullets-li">
            <a href="#process-item-1" class="process__diagram--bullet"></a>
          </li>

          <li class="process__diagram--bullets-li">
            <a href="#process-item-2" class="process__diagram--bullet"></a>
          </li>

          <li class="process__diagram--bullets-li">
            <a href="#process-item-3" class="process__diagram--bullet"></a>
          </li>

          <li class="process__diagram--bullets-li">
            <a href="#process-item-4" class="process__diagram--bullet"></a>
          </li>
          <li class="process__diagram--bullets-li">
            <a href="#process-item-5" class="process__diagram--bullet"></a>
          </li>
        </ul>

      </div>

      <div class="process__download">
        <button @click="openModal" class="process__download--a">
          Ver proceso completo
        </button>
      </div>

    </div>

    <!-- Modal -->
    <Transition name="modal">
      <div v-if="isModalOpen" class="process-modal" @click.self="closeModal">
        <div class="process-modal__content">
          <button class="process-modal__close" @click="closeModal">
            <i class="ri-close-line"></i>
          </button>

          <div class="process-modal__header">
            <h2 class="process-modal__title">Proceso Completo de Exámenes Preocupacionales</h2>
            <p class="process-modal__subtitle">Acompañamiento integral desde la solicitud hasta la gestión financiera</p>
          </div>

          <div class="process-modal__steps">
            <!-- Fase 1 -->
            <div class="process-modal__step process-modal__step--yellow">
              <div class="process-modal__step-header">
                <div class="process-modal__step-icon">
                  <i class="ri-calendar-schedule-line"></i>
                </div>
                <div class="process-modal__step-info">
                  <span class="process-modal__step-badge">Fase 1</span>
                  <h3 class="process-modal__step-title">Solicitud de atención</h3>
                  <p class="process-modal__step-description">Ingreso y organización de solicitudes de exámenes preocupacionales o ocupacionales enviadas por las empresas.</p>
                </div>
              </div>
              <div class="process-modal__step-features">
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Registro de trabajadores y exámenes solicitados.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Validación de disponibilidad por sucursal o recursos.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Control de estados: ingresada, programada, pendiente.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Minimiza errores y agiliza la programación.</span>
                </div>
              </div>
            </div>

            <!-- Conector -->
            <div class="process-modal__connector"></div>

            <!-- Fase 2 -->
            <div class="process-modal__step process-modal__step--orange">
              <div class="process-modal__step-header">
                <div class="process-modal__step-icon">
                  <i class="ri-stethoscope-line"></i>
                </div>
                <div class="process-modal__step-info">
                  <span class="process-modal__step-badge">Fase 2</span>
                  <h3 class="process-modal__step-title">Atención de paciente</h3>
                  <p class="process-modal__step-description">Gestión completa del flujo del paciente dentro del centro médico, desde sala de espera hasta la realización de exámenes.</p>
                </div>
              </div>
              <div class="process-modal__step-features">
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Llamado a box mediante turnomático.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Registro de resultados clínicos, muestras y procedimientos.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Control de exámenes realizados y pendientes.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Gestión tanto para pacientes de empresas como particulares.</span>
                </div>
              </div>
            </div>

            <!-- Conector -->
            <div class="process-modal__connector"></div>

            <!-- Fase 3 -->
            <div class="process-modal__step process-modal__step--coral">
              <div class="process-modal__step-header">
                <div class="process-modal__step-icon">
                  <i class="ri-file-edit-line"></i>
                </div>
                <div class="process-modal__step-info">
                  <span class="process-modal__step-badge">Fase 3</span>
                  <h3 class="process-modal__step-title">Firma y emisión de informes</h3>
                  <p class="process-modal__step-description">Generación, revisión y firma digital de informes médicos y psicológicos con validez legal.</p>
                </div>
              </div>
              <div class="process-modal__step-features">
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Firma digital segura por profesional responsable.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Validación mediante código QR.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Asignación de vigencias según criterio clínico.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Emisión automatizada y trazabilidad del documento.</span>
                </div>
              </div>
            </div>

            <!-- Conector -->
            <div class="process-modal__connector"></div>

            <!-- Fase 4 -->
            <div class="process-modal__step process-modal__step--pink">
              <div class="process-modal__step-header">
                <div class="process-modal__step-icon">
                  <i class="ri-hospital-line"></i>
                </div>
                <div class="process-modal__step-info">
                  <span class="process-modal__step-badge">Fase 4</span>
                  <h3 class="process-modal__step-title">Operaciones</h3>
                  <p class="process-modal__step-description">Centralización del historial, seguimiento y control operativo de todas las atenciones.</p>
                </div>
              </div>
              <div class="process-modal__step-features">
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Gestión de solicitudes y estados operativos.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Acceso a historial completo de baterías y exámenes.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Organización de pendientes por empresa o particular.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Registro unificado para toma de decisiones y auditorías.</span>
                </div>
              </div>
            </div>

            <!-- Conector -->
            <div class="process-modal__connector"></div>

            <!-- Fase 5 -->
            <div class="process-modal__step process-modal__step--green">
              <div class="process-modal__step-header">
                <div class="process-modal__step-icon">
                  <i class="ri-line-chart-line"></i>
                </div>
                <div class="process-modal__step-info">
                  <span class="process-modal__step-badge">Fase 5</span>
                  <h3 class="process-modal__step-title">Finanzas</h3>
                  <p class="process-modal__step-description">Administración de prefacturas, facturación y conciliación de pagos derivados de las atenciones realizadas.</p>
                </div>
              </div>
              <div class="process-modal__step-features">
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Generación de prefacturas por empresa o servicio.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Emisión de facturas electrónicas (DTE).</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Gestión de cuentas por cobrar y pagos conciliados.</span>
                </div>
                <div class="process-modal__feature">
                  <i class="ri-check-line"></i>
                  <span>Histórico de ventas y reportes financieros.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>

  </section>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';

const isModalOpen = ref(false);

const openModal = () => {
  isModalOpen.value = true;
  document.body.style.overflow = 'hidden';
};

const closeModal = () => {
  isModalOpen.value = false;
  document.body.style.overflow = '';
};

onMounted(async () => {
  initializeProcessDiagram()
})


const initializeProcessDiagram = (): void => {
  document.addEventListener('DOMContentLoaded', () => {
    const content = document.querySelector<HTMLElement>('.process__diagram--content');
    const bullets = document.querySelectorAll<HTMLElement>('.process__diagram--bullet');
    const items = document.querySelectorAll<HTMLElement>('.process__diagram--item');
    let autoScrollInterval: number | undefined;

    if (content) {
      const updateActiveBullet = (): void => {
        const scrollLeft = content.scrollLeft;
        const scrollWidth = content.scrollWidth - content.clientWidth;
        const index = Math.round((scrollLeft / scrollWidth) * (bullets.length - 1));
        bullets.forEach((bullet, i) => {
          bullet.classList.toggle('active', i === index);
        });
      };

      const scrollToItem = (index: number): void => {
        const targetItem = items[index];
        if (targetItem) {
          const itemOffset = targetItem.offsetLeft - content.offsetLeft;
          content.scrollTo({ left: itemOffset, behavior: 'smooth' });
        }
      };

      const startAutoScroll = (): void => {
        autoScrollInterval = window.setInterval(() => {
          const scrollLeft = content.scrollLeft;
          const scrollWidth = content.scrollWidth - content.clientWidth;
          const currentIndex = Math.round((scrollLeft / scrollWidth) * (bullets.length - 1));
          const nextIndex = (currentIndex + 1) % items.length;
          scrollToItem(nextIndex);
        }, 3000);
      };

      const stopAutoScroll = (): void => {
        if (autoScrollInterval !== undefined) {
          clearInterval(autoScrollInterval);
        }
      };

      bullets.forEach((bullet, index) => {
        bullet.addEventListener('click', (e: Event) => {
          e.preventDefault();
          stopAutoScroll();
          scrollToItem(index);
          startAutoScroll();
        });
      });

      items.forEach((item) => {
        item.addEventListener('mouseenter', stopAutoScroll);
        item.addEventListener('mouseleave', startAutoScroll);
      });

      content.addEventListener('scroll', updateActiveBullet);
      updateActiveBullet(); // Inicializa la clase active en el bullet correcto

      startAutoScroll(); // Inicia el scroll automático
    }
  });
}


</script>

<style scoped>
/* Modal Styles */
.process-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  overflow-y: auto;
}

.process-modal__content {
  background: white;
  border-radius: 24px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 40px;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.process-modal__close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #f1f5f9;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 24px;
  color: #64748b;
}

.process-modal__close:hover {
  background: #e2e8f0;
  transform: rotate(90deg);
}

.process-modal__header {
  text-align: center;
  margin-bottom: 40px;
}

.process-modal__title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.process-modal__subtitle {
  font-size: 16px;
  color: #64748b;
}

.process-modal__steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.process-modal__step {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}

.process-modal__step:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.process-modal__step-header {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.process-modal__step-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  flex-shrink: 0;
  color: white;
}

.process-modal__step--yellow .process-modal__step-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.process-modal__step--orange .process-modal__step-icon {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
}

.process-modal__step--coral .process-modal__step-icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.process-modal__step--pink .process-modal__step-icon {
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
}

.process-modal__step--green .process-modal__step-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}


.process-modal__step-info {
  flex: 1;
}

.process-modal__step-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
  color: white;
}

.process-modal__step--yellow .process-modal__step-badge {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.process-modal__step--orange .process-modal__step-badge {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
}

.process-modal__step--coral .process-modal__step-badge {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.process-modal__step--pink .process-modal__step-badge {
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
}

.process-modal__step--green .process-modal__step-badge {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}


.process-modal__step-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.process-modal__step-description {
  font-size: 14px;
  color: #64748b;
}

.process-modal__step-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
}

.process-modal__feature {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: #475569;
}

.process-modal__feature i {
  color: #10b981;
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.process-modal__connector {
  width: 2px;
  height: 24px;
  background: linear-gradient(to bottom, #e2e8f0 0%, transparent 100%);
  margin: 0 auto;
}

/* Modal Transitions */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-active .process-modal__content,
.modal-leave-active .process-modal__content {
  transition: transform 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .process-modal__content {
  transform: scale(0.9) translateY(20px);
}

.modal-leave-to .process-modal__content {
  transform: scale(0.9) translateY(20px);
}

/* Responsive */
@media (max-width: 768px) {
  .process-modal__content {
    padding: 24px;
    max-height: 95vh;
  }

  .process-modal__title {
    font-size: 22px;
  }

  .process-modal__step-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .process-modal__step-features {
    grid-template-columns: 1fr;
  }
}
</style>
